function toggleNavigation() {
  if ($('.menu-bar').length > 0) {
    const menuHeight = $(window).height();
    const menuLinksHeight = $(window).height() - $('.menu-bar').height() - $('.menu').height();

    $('.menu-links').height(menuLinksHeight);

    $('.hamburger-menu').on('click', function() {
      $('.bar').toggleClass('animate');
      $('body').toggleClass('disable-scroll');
      if ($('.mobile .has-submenu').hasClass('show-submenu')) {
        $('.mobile .has-submenu').removeClass('show-submenu');
      }
      if ($('.mobile header').hasClass('show-menu')) {
        $('.mobile header').removeClass('show-menu');
        setTimeout(function() {
          $('.header-wrap').css('height', '80px');
        }, 500);
      } else {
        $('.header-wrap').height(menuHeight);
        $('.mobile header').addClass('show-menu');
      }
    });

    $('.mobile .menu .has-submenu a').on('click', function () {
      $(this).parent().toggleClass('show-submenu');
    });

    $('.arrow-back').on('click', function () {
      $(this).parent().parent().removeClass('show-submenu');
    });
  }
}

export default { toggleNavigation };



// WEBPACK FOOTER //
// ./src/js/custom/mobile-navigation.js